import React from "react";
import { Link } from "react-router-dom";

import styles from "./style.module.scss";

function Index(props) {

    return (
        <div className={styles.MainNav}>
            <h2>
                <Link to="/">
                    TOP<span className={styles.yellow}>UP</span>LAB
                </Link>
            </h2>
            <Link to="/login">
                <button>Login</button>
            </Link>
        </div>
    );
}

export default Index;
